exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#basket-btn.v-btn--disabled[data-v-59988d56] {\n    background-color: #ddd!important;\n    color: #eee!important;\n}\n", ""]);

// exports
